import StoreIndexTable from "./StoreIndexTable";
export default StoreIndexTable;
